import { render, staticRenderFns } from "./configuration-automation-personnel-entities-association-modal-sample-type-assignment-form.vue?vue&type=template&id=31a319b6&scoped=true&"
import script from "./configuration-automation-personnel-entities-association-modal-sample-type-assignment-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-personnel-entities-association-modal-sample-type-assignment-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-personnel-entities-association-modal-sample-type-assignment-form.scss?vue&type=style&index=0&id=31a319b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a319b6",
  null
  
)

export default component.exports